<tt-page *ngIf="page">
    <tt-card class="col-xs-12 sp-0">
        <label *ngIf="page.page_heading > ''" class="checklist-h1e col-xs-12">{{ page.page_heading | uppercase }}</label>
        <tt-input ttLabel="resource_name" [ttModel]="page.resource_name" ttReadonly></tt-input>
        <tt-button ttText="srchecklistcrews_srcrews" ttIcon="fas fa-chevron-right" ttIconPullRight ttTextAlign="left" ttGoto="srcrews" [ttGotoParms]="{ argtype: 'resource_id', argvalue: page.resource_id }"></tt-button>
        <tt-button ttText="srchecklistcrews_add" ttIcon="fas fa-plus" ttIconPullRight ttTextAlign="left" ttGoto="srchecklistcrewchange" [ttGotoParms]="{ checklistdata_keyno: page.checklistdata_keyno }"></tt-button>
        <tt-list [ttData]="crews"></tt-list>
    </tt-card>
</tt-page>
